import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { IHeaderParams } from 'ag-grid-community';

interface CustomIHeaderParams extends IHeaderParams {
  singleMenu?: boolean,
  onSort?: (param1: 'asc' | 'desc' | null, param2: string) => void;
  getSortDirection?: (colId: string) => 'asc' | 'desc' | null;
  hasIcon?: boolean;
}

@Component({
  selector: 'app-custom-header',
  templateUrl: './custom-header.component.html',
  styleUrls: ['./custom-header.component.scss'],
})
export class CustomHeaderComponent implements AfterViewInit {
  params!: CustomIHeaderParams;
  currentSort: 'asc' | 'desc' | null = null;
  isPinned = false;
  sortIcon = 'swap_vert';
  isFiltered = false;
  hasHeaderActions = true;
  hideLabel!: boolean;
  menuActive = false;
  showMenu = true

  constructor(private readonly cdr: ChangeDetectorRef) {}

  @ViewChild('icons') iconsRef!: ElementRef;
  iconsWidth: number = 0;

  mapHideActions = {
    'ações': true,
    'actions':true,
    'expand': true,
    'expand-fake':true
  }
  mapHideLabel  = {
    'expand': true,
    'expand-fake':true
  }

  mapActions = {}
  

  agInit(params: IHeaderParams): void {
    this.showMenu = params.column.getColDef().sortable || !params.column.getColDef().lockPinned || params.column.getColDef().filter
    this.hasHeaderActions = !this.mapHideActions[params.displayName.toLocaleLowerCase()]
    this.hideLabel = this.mapHideLabel[params.displayName.toLocaleLowerCase()]
    this.params = params;
    this.updateSortState();
    this.checkIfFiltered();
  
    this.params.api.addEventListener('filterChanged', () => {
      this.checkIfFiltered();
    });

  }

  handleSort(): void {
    const newSort =
      this.currentSort === 'asc'
        ? 'desc'
        : this.currentSort === 'desc'
        ? null
        : 'asc';
    const colId = this.params.column.getColId();

    const field = this.params.columnApi.getColumn(colId)?.getColDef().field || ''
    this.currentSort = newSort;
    this.updateSortIcon();

    if (this.params.onSort) {
      this.params.onSort(newSort, field);
    }

    this.cdr.detectChanges();
  }

  updateSortIcon(): void {
    this.sortIcon =
      this.currentSort === 'asc'
        ? 'arrow_drop_up'
        : this.currentSort === 'desc'
        ? 'arrow_drop_down'
        : 'swap_vert';
  }

  updateSortState(): void {
    const colId = this.params.column.getColId();

    if (this.params.getSortDirection) {
      this.currentSort = this.params.getSortDirection(colId);
    } else {
      this.currentSort = null;
    }

    this.sortIcon =
      this.currentSort === 'asc'
        ? 'arrow_drop_up'
        : this.currentSort === 'desc'
        ? 'arrow_drop_down'
        : 'swap_vert';
  }

  togglePin(): void {
    this.isPinned = this.params.column.isPinned();
    this.params.columnApi.setColumnPinned(
      this.params.column,
      this.isPinned ? null : 'left'
    );
  }

  openFilter(event): void {
    if(this.params.singleMenu){
      this.menuActive = true;
      const column = this.params.column;

      const listener = () => {
        this.menuActive = false; 
        column.removeEventListener('menuVisibleChanged', listener); 
        this.cdr.detectChanges();
      };

      column.addEventListener('menuVisibleChanged', (event) => {
        if (!event.column.menuVisible) {
          listener();
        }
      });
    }
    this.params.api.showColumnMenuAfterButtonClick(
      this.params.column.getColId(),
      event.currentTarget
    );
    
  }

  checkIfFiltered(): void {
    const filterModel = this.params.api.getFilterModel();
    const colId = this.params.column.getColId();
    this.isFiltered = filterModel[colId]?.selectedValues.length > 0;
  }


  ngAfterViewInit(): void {
 
    if (this.iconsRef) {
      this.iconsWidth = this.iconsRef.nativeElement.offsetWidth;
      this.cdr.detectChanges()
    }
  }


}
